<template>
    <div>
        <form action="" @submit.prevent>
            <div class="field has-addons lb-message-input">
                <div class="control is-expanded lb-clean-input lb-grow">
                    <textarea
                        ref="messageInput"
                        v-model="userAnswer"
                        :placeholder="$t('write_answer')"
                        class="textarea has-fixed-size is-small is-size-6 lb-grow"
                        type="text"
                    />
                </div>
            </div>
        </form>
        <div class="control pt-4">
            <button
                v-t="'Buttons.validate'"
                class="button is-primary"
                @click="checkAnswer"
            ></button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        answers: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            userAnswer: '',
        };
    },
    computed: {
        answer() {
            return this.normalize(this.answers[0].value);
        },
    },
    methods: {
        normalize(text = '') {
            return text
                .normalize('NFD')
                .replace(/[\u0300-\u0302\u0304-\u0326\u0328-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9]/g, '')
                .toUpperCase();
        },
        checkAnswer() {
            this.$emit('answer', {
                answer: { value: this.userAnswer },
                correct: this.normalize(this.userAnswer) == this.answer,
            });
        },
    },
};
</script>

<style></style>
